import type { WorkflowApi } from '../api/WorkflowApi'
import type {
  InstructionWriteBody,
  WorkflowInstruction,
  WorkflowScope,
} from '../models/workflow.types'

const INSTRUCTION_IDENTITY = {
  scope_type: 'workspace_all',
  instruction_key: 'global_grounding',
  instruction_name: 'Global Grounding',
} as const

export interface SaveInstructionFlowOptions {
  api: Pick<WorkflowApi, 'createInstruction' | 'updateInstruction'>
  notifySuccess: (updated: boolean) => void
  reload: () => Promise<void>
}

export class SaveInstructionFlow {
  constructor(private readonly options: SaveInstructionFlowOptions) {}

  async execute(
    scope: WorkflowScope,
    instructionText: string,
    existing?: WorkflowInstruction | null,
  ): Promise<WorkflowInstruction> {
    const body: InstructionWriteBody = {
      ...INSTRUCTION_IDENTITY,
      instruction_text: instructionText.trim(),
    }
    const instruction = existing
      ? await this.options.api.updateInstruction(scope, existing.id, body)
      : await this.options.api.createInstruction(scope, body)
    this.options.notifySuccess(Boolean(existing))
    await this.options.reload()
    return instruction
  }
}
